module.exports = __webpack_public_path__ + "static/media/HospedeCosta2.a57991dc.jpeg";